module.exports = __webpack_public_path__ + "static/media/20180203_103146.44ce54c9.jpg";